import styled from 'styled-components';
import { ellipsis } from '../../../styles/common';
import { flex } from '../../../styles/layout';
import {
  body,
  bodySmall,
  poppinsMediumFont,
  poppinsRegularFont,
  poppinsSemiBoldFont,
  subTitle,
} from '../../../styles/typography';
import { COLORS } from '../../../styles/colors';
export type RowDirectionType = 'column' | 'row';
export type RowOffsetType = 'default' | 'small';

export const Row = styled.div<{
  hasHighlight?: boolean;
  hasBorder?: boolean;
  direction?: RowDirectionType;
  offset?: RowOffsetType;
  isHeader?: boolean;
}>`
  ${flex({ justifyContent: 'space-between' })};
  ${bodySmall};
  margin-bottom: 12px;
  position: relative;
  z-index: 2;
  overflow: hidden;
  ${({ hasHighlight }) =>
    hasHighlight &&
    `
    background: linear-gradient(270deg, #D8FFF0 31.59%, rgba(255, 255, 255, 0) 100%);
  `}

  ${({ hasBorder }) =>
    hasBorder &&
    `
    border-top: 1px solid ${COLORS.grey[400]};
    border-bottom: 1px solid ${COLORS.grey[400]};
    padding: 12px 0;
  `}
  
  ${({ direction }) =>
    direction &&
    `
    flex-direction: ${direction};
  `}
  
  ${({ offset }) =>
    offset === 'small' &&
    `
    margin-bottom: 8px;
  `}

  ${({ isHeader }) =>
    isHeader &&
    `
    margin-bottom: 16px;
  `}

  &:last-child {
    margin-bottom: 0;
  }
`;
export const RowName = styled.div<{ isHeader?: boolean }>`
  ${flex({ alignItems: 'center' })};
  gap: 8px;
  flex-shrink: 0;
  margin-right: 25px;
  ${poppinsRegularFont};
  ${bodySmall};
  color: ${COLORS.grey[600]};

  ${({ isHeader }) =>
    isHeader &&
    `
    ${poppinsMediumFont};
    ${body};
    color: ${COLORS.black};
  `}
`;
export const RowValue = styled.div<{ hasBorder?: boolean; direction: 'column' | 'row' }>`
  ${poppinsMediumFont};
  ${ellipsis};
  color: ${COLORS.black};

  ${({ hasBorder }) =>
    hasBorder &&
    `
    ${poppinsSemiBoldFont};
    ${body};
  `}

  ${({ direction }) =>
    direction === 'column' &&
    `
    ${subTitle};
  `}
`;
